import { render, staticRenderFns } from "./LiveList.vue?vue&type=template&id=0396b4b3&scoped=true"
import script from "./LiveList.vue?vue&type=script&lang=js"
export * from "./LiveList.vue?vue&type=script&lang=js"
import style0 from "./LiveList.vue?vue&type=style&index=0&id=0396b4b3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0396b4b3",
  null
  
)

export default component.exports